module.exports = __webpack_public_path__ + "3ad35330149b9c80f6867f1babf94031.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/mastercard.png
// module id = 502
// module chunks = 0